import React, {
  createContext, useContext, useEffect, useState,
} from 'react';

const ClientErrorContext = createContext({
  clientError: false,
  setClientError: () => {},
});

let globalSetClientError = () => {};

export const notifyClientError = (value) => {
  if (globalSetClientError) {
    globalSetClientError(value);
  }
};

export function ClientErrorProvider({ children }) {
  const [clientError, setClientError] = useState(false);

  useEffect(() => {
    globalSetClientError = setClientError;
    return () => {
      globalSetClientError = () => {};
    };
  }, []);

  const contextValue = React.useMemo(
    () => ({ clientError, setClientError }),
    [clientError, setClientError],
  );

  return (
    <ClientErrorContext.Provider value={contextValue}>
      {children}
    </ClientErrorContext.Provider>
  );
}

export const useClientError = () => useContext(ClientErrorContext);
